export default "__VITE_ASSET__DLNYH7a1__"